import React, { useState, useRef, useCallback } from "react";
import { Blurhash } from "react-blurhash";

const GalleryImage = ({ src, hash, alt, priority = false }) => {
  const [loaded, setLoaded] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(priority);
  const containerRef = useRef(null);

  const observerRef = useCallback(
    (node) => {
      if (node && !shouldLoad) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setShouldLoad(true);
              observer.disconnect();
            }
          },
          {
            rootMargin: "100px",
            threshold: 0.1,
          }
        );
        observer.observe(node);
        return () => observer.disconnect();
      }
    },
    [shouldLoad]
  );

  const handleLoad = useCallback(() => {
    setLoaded(true);
  }, []);

  const handleError = useCallback((e) => {
    e.target.onerror = null;
    e.target.src = "https://via.placeholder.com/400x300?text=Image+Not+Found";
    setLoaded(true);
  }, []);

  return (
    <div
      ref={(node) => {
        containerRef.current = node;
        observerRef(node);
      }}
      className="gallery-image-wrapper"
    >
      {!loaded && shouldLoad && (
        <Blurhash
          hash={hash}
          width="100%"
          height="100%"
          resolutionX={32}
          resolutionY={32}
          punch={1}
        />
      )}
      {shouldLoad && (
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          onLoad={handleLoad}
          onError={handleError}
          className={`gallery-img ${loaded ? "gallery-image-loaded" : ""}`}
        />
      )}
    </div>
  );
};

export default GalleryImage;
